import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';

class TabAyudaAgente extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        return (
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                        ><p className="text-primary">Estado del módulo</p></NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}
                        ><p className="text-primary">Flujo de atención</p></NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            onClick={() => { this.toggle('3'); }}
                        ><p className="text-primary">Atención de Urgencia</p></NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '4' })}
                            onClick={() => { this.toggle('4'); }}
                        ><p className="text-primary">Suspensión</p></NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        <Row>
                            <Col sm="12">
                                <p>Los módulos poseen 3 estados:</p>
                                <p>Cerrado: No se están recibiendo usuarios para atender.</p>
                                <p>Suspendido: No se están recibiendo usuarios para atender, pero el módulo se activará una vez terminado el tiempo de suspensión.</p>
                                <p>Activo: El módulo está en funcionamiento gestionando los turnos de atención a usuarios</p>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                        <p>Para que el flujo de turnos funcione, el módulo debe estar en estado "Activo".</p>
                            <p>El Flujo de turnos es:</p>
                            <p>1. Siguiente Turno: Se solicita al usuario a través de la pantalla de información que se acerque al módulo.</p>
                            <p>1.1 Finalizar Turno: La atención finalizó, se le solicita al usuario una calificación del servicio brindado...</p>
                        </Row>
                    </TabPane>
                    <TabPane tabId="3">
                        <Row>
                            <p>Este caso sucede cuando un Usuario llegó al módulo de atención de manera espontánea sin solicitar un turno y su atención se puede realizar de manera inmediata.</p>
                            <p>Es necesario hacer click en el botón "Atención de Urgencia", en donde se solicitará la ID del usuario, el nombre del usuario y el tipo de servicio que se brindó.</p>
                        </Row>
                    </TabPane>
                    <TabPane tabId="4">
                        <Row>
                            <p>Los módulos podrán ser suspendidos por cierto periodo de tiempo:</p>
                            <p>- Break: 10 Minutos</p>
                            <p>- Almuerzo: 1 Hora</p>
                            <p>- Baño: 5 Minutos</p>
                            <p>- Otro (Personalizable): 5 - 15 Minutos</p>
                            <p>Una vez finalizado el tiempo desde que se realizó la suspensión, el módulo quedará activo automáticamente.</p>
                        </Row>
                    </TabPane>
                </TabContent>
            </div>
        );
    }
}
export default TabAyudaAgente;